import styled from 'styled-components'

export const StickyTabMenu = styled.div`
  position: sticky;
  top: 0;
  z-index: 10;
  background: white;
`

export const StatsSection = styled.section`
  margin-bottom: 20px;
`
